(function() {
  exports.register = function(module) {
    return module.factory('Core.Services.MapLayers.Soil', [
      '$injector', function($injector) {
        return {
          "new": function() {
            var service;
            service = $injector.get('Core.Services.MapLayers.Base')["new"]();
            service.url = 'backend/grower/layers/soil/get';
            return service;
          }
        };
      }
    ]);
  };

}).call(this);
